module.exports = __webpack_public_path__ + "img/1471868505.1ed2ead1.jpg";